<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import util from "@/common/js/index";

export default {
  data() {
    return {
      flag: false,
    };
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  mounted() {
    // let userType = localStorage.getItem("userType");
    // if (userType && JSON.parse(userType)?.[0].userType === 3) {
    //   this.$router.push("/teaIndex");
    // }

    if (sessionStorage.getItem("changemakeTai")) {
      this.$router.push("/userInfo/workTable");
    }
    for (const item of util.utils.iconfontUrl) {
      let iconLink = document.createElement("link");
      iconLink.rel = "stylesheet";
      iconLink.href = item;
      document.head.appendChild(iconLink);
    }
    this.setGlobalStyle();
    setInterval(() => {
      this.refreshToken();
    }, 1000 * 60);

    //设置窗口图标ico
    if (sessionStorage.getItem("tenantData")) {
      const tenantInfo = JSON.parse(sessionStorage.getItem("tenantData"));
      var link =
        document.querySelector('link[rel*="icon"]') ||
        document.createElement("link");
      link.rel = "icon";
      link.href = tenantInfo.htmlIcoImage || "";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  },
  methods: {
    setGlobalStyle() {
      const root = document.documentElement;
      root.style.setProperty("--border-color", "#ebeef5");
      root.style.setProperty("--shallow-color", "#a4a8b0");
      root.style.setProperty("--delete-color", "#ed3f14");
      root.style.setProperty("--tree-background-color", "#f3f5fc");
    },
    refreshToken() {
      const token = JSON.parse(localStorage.getItem("token"));
      // 每隔一分钟去判断token过期时间是否小于当前时间5分钟
      if (token && token.expTime - Date.now() < 1000 * 60 * 5) {
        this.$http({
          url: "/v1/identity-service/api/account/refreshToken",
          method: "post",
          data: {
            refreshToken: token.refreshToken,
          },
        })
          .then((res) => {
            localStorage.setItem(
              "token",
              JSON.stringify({
                accessToken: res.accessToken,
                encryptedAccessToken: res.encryptedAccessToken,
                refreshToken: res.refreshToken,
                expTime: res.expireInSeconds * 1000 + Date.now(),
              }),
            );
          })
          .catch((error) => {
            this.logout();
          });
      }
    },
    logout() {
      this.$http({
        url: "/v1/identity-service/api/account/logout",
        method: "post",
      }).then((res) => {
        let tenantCode = JSON.parse(localStorage.getItem("user"))?.tenantCode;
        localStorage.clear();
        sessionStorage.clear();
        if (tenantCode) {
          window.location.replace(`/${tenantCode}/login`);
        } else {
          window.location.replace("/login");
        }
        // window.open(`https://www.ahjxjy.cn`, "_self");
      });
    },
  },
};
</script>
<style lang="scss">
@import "@/common/css/index.scss";
@import "@/common/css/public.scss";
body {
  height: 100%;
}
#app {
  height: 100%;
}
.content {
  width: 100%;
  overflow-y: auto;
  flex: 1;
  background: #f0f2f5;
  .center {
    height: 100%;
    position: relative;
    background: #f5f7f9;
    overflow: hidden;
    overflow-y: auto;
  }
}
.el-button--small {
  font-size: 14px !important;
}
</style>
